// extracted by mini-css-extract-plugin
module.exports = {"Panel":"TestSuitePanel_Panel__2dODa","Loading":"TestSuitePanel_Loading__0t_tk"};